module.exports = __webpack_public_path__ + "static/brama-4f8759088e76827c3f02be9820c4ce33.jpg";